export enum REAL_ESTATE_CAPITAL_TYPE {
  FIXED_CAPITAL = 'fixe',
}
